// COM-638 fix wave (review round 3): `SourcesContext#fetchArticlesFeed`'s
// promise can reject for several materially different reasons -
//   - a socket disconnect/reconnect while a reply was still pending
//     (`rejectPendingArticlesFeedRequests`)
//   - a server-side failure, echoed back as an `articlesFeedLoaded` reply
//     carrying `error: true` (see `backend/src/index.ts`'s `getArticlesFeed`
//     handler)
//   - the client-side safety-net timeout (`ARTICLES_FEED_TIMEOUT_MS` in
//     SourcesContext.tsx), which exists precisely because a server-side
//     failure is not guaranteed to reach the frontend as a matching reply at
//     all (an access-guard rejection in `projectAccessCheck` never even
//     calls the `getArticlesFeed` handler, so it can't emit one)
// `AllArticlesPage` needs to tell the FIRST reason apart from the other two:
// only a genuine disconnect gets the "Connection lost" treatment: a
// full-width EmptyState/banner offering Retry, not a plain error toast.
//
// A previous version told them apart with a message regex
// (`/disconnect|reconnect/i` in `isFeedDisconnectError`) - fragile by
// construction. It happened to work only because, at the time, disconnect/
// reconnect were the ONLY rejection reasons `fetchArticlesFeed` could ever
// produce, so the regex matched every rejection there was; a real
// non-disconnect rejection (the two above) never existed to prove the regex
// wrong. This class makes the distinction structural instead: SourcesContext
// throws exactly this type for the disconnect/reconnect paths, and
// `isFeedDisconnectError` (allArticlesFeed.ts) checks `instanceof` - correct
// regardless of how any rejection's message happens to be worded.
export class FeedSocketDisconnectError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FeedSocketDisconnectError';
    // Restores the prototype chain: TypeScript's ES5-targeting `class ...
    // extends Error` transpilation can otherwise break `instanceof` checks
    // against subclasses depending on target/lib settings. Belt-and-braces
    // rather than a proven issue under CRA's actual config.
    Object.setPrototypeOf(this, FeedSocketDisconnectError.prototype);
  }
}
